const LEGACY_CLIENT_ORIGINS = [
  'https://providencedb.com',
  'https://uat.redesign.prvdnc.d10.aisnovations.com',
];

const parseNotificationUrl = (
  value: string | null | undefined,
  baseUrl: string,
): URL | undefined => {
  if (!value?.trim()) {
    return undefined;
  }

  try {
    const url = new URL(value, baseUrl);

    if (
      !['https:', 'http:'].includes(url.protocol) ||
      url.username ||
      url.password
    ) {
      return undefined;
    }

    return url;
  } catch {
    // Malformed persisted URLs must not become clickable or load remote assets.
    return undefined;
  }
};

export const getNotificationRedirectUrl = (
  value: string | null | undefined,
  clientOrigin: string,
): string | undefined => {
  const url = parseNotificationUrl(value, `${clientOrigin}/`);

  if (
    !url ||
    (url.origin !== clientOrigin && !LEGACY_CLIENT_ORIGINS.includes(url.origin))
  ) {
    return undefined;
  }

  // Assigning URL parts avoids treating a leading // in a path as a new host.
  const destination = new URL(clientOrigin);

  destination.pathname = url.pathname;
  destination.search = url.search;
  destination.hash = url.hash;

  return destination.href;
};

export const getNotificationIconUrl = (
  value: string | null | undefined,
  apiUrl: string,
): string | undefined => {
  const url = parseNotificationUrl(value, `${apiUrl}/`);

  if (!url || !/^\/notification\/(info|alert)\.png$/.test(url.pathname)) {
    return undefined;
  }

  return new URL(url.pathname, apiUrl).href;
};
